import { get, isEmpty } from 'lodash';
import * as React from 'react';
import { useEffect } from 'react';
import { nonPiletInstances, PILET_NAMES } from '../../configs/config';
import { STORAGE_KEYS } from '../../Utils/constants';
import { getItem, removeItem, setItem } from '../../Utils/Storage';
import { parseQueryParams, redirectTo } from '../../Utils/utils';
import useLoans from './useLoans';

import { initializeContainer } from '../../Utils/configuration';
import { Loading } from '../UI/loading';
import { gamification } from '../../api/event';
import NCModal from '../Modal';
import Header from '../Header';

const Loans = () => {
  const { generateCode, setParams, params, data, isFailed, isSuccess } =
    useLoans();
  const [showModal, setModal] = React.useState(false);
  const [digioParams, setDigioParams] = React.useState('');
  const [d, setD] = React.useState({
    isLoading: true,
    showFrame: false
  });

  const hideLoading = () => {
    setD({
      ...d,
      isLoading: false
    });
  };

  const pathname = location.pathname;
  const [, , nextScreen] = pathname.split('/');
  const query = get(location, 'search', '');

  if (isEmpty(query)) {
    removeItem(STORAGE_KEYS.APP_NAME);
  }

  const [fintechConfig]: any = nonPiletInstances.filter(
    ({ appName }) => appName === PILET_NAMES.FINTECH
  );

  let loansData = {};
  const dashboardData = localStorage.getItem('DASHBOARD_DATA');

  const handleIframe = (isAuthData = false) => {
    try {
      const parsedDashboardData = JSON.parse(dashboardData);
      let auth =
        isEmpty(query) || isAuthData
          ? JSON.parse(localStorage['AUTH_CONFIG'])
          : data;
      let realmData = get(auth, 'realms[0]', undefined);
      if (!realmData) {
        realmData = get(auth, 'userRealmsDetails.realms[0]', undefined);
      }
      loansData = {
        token: auth?.token || auth?.access_token,
        token_type: auth?.token_type,
        realmIdentifier: realmData?.realmIdentifier,
        existingUser: auth?.existingUser,
        userId: auth?.userId,
        loggedInUserId: parsedDashboardData?.userId || null,
        loggedInRealmId: parsedDashboardData?.realmId || null,
        businessName: realmData?.realmName || data?.userName,
        traderName: realmData?.realmName || data?.userName,
        name: realmData?.realmName || data?.userName,
        contactNumber: realmData?.contactNumber || data?.contactNumber,
        customDomain: process.env.CUSTOM_DOMAIN,
        to: params?.screen,
        loanId: params?.loanId,
        applicationName: params?.applicationName
          ? decodeURIComponent(params?.applicationName)
          : null
      };
    } catch (e) {
      console.error('failed to parsed fintech data', e);
    }
    try {
      loansData = {
        authData: JSON.stringify(loansData),
        // dashboardData: parsedDashboardData,
        customDomain: process.env.CUSTOM_DOMAIN,
        appName: getItem(STORAGE_KEYS.APP_NAME),
      };
    } catch (e) {
      console.error('error parsing dashboarddata', e);
    }
    window.addEventListener('message', (event) => {
      const action = get(event, 'data.action', '');
      const agnetUser = get(event, 'data.agnetUser', undefined);
      const rupifyUrl = get(event, 'data.rupifyUrl','')
      if (action === 'get_detail') {
        setTimeout(() => {
          const frame: any = document.getElementById('loansframe');
          const fintechUser = localStorage.getItem('FINTECH_USER_ID');
          const appName = localStorage.getItem('APP_NAME');

          const isSameUser =
            params?.userId || appName === 'lending-loans'
              ? fintechUser == params?.userId
              : true;
          if (frame?.contentWindow && isSameUser) {
            frame.contentWindow.postMessage(
              {
                call: 'sendValue',
                value: loansData
              },
              '*'
            );
          }
        }, 3000);
      } else if (action === 'close_fintech') {
        const iframes: any = document.getElementById('loansframe');
        if (iframes?.remove) {
          iframes.remove();
        }
        // iframes.parentNode?.removeChild()
        const appName = localStorage.getItem(STORAGE_KEYS.APP_NAME);
        if (!isEmpty(appName) && appName.includes('lending-loans')) {
          history.pushState('', '', '/lending-loans');

          var popStateEvent = new PopStateEvent('popstate', {});
          dispatchEvent(popStateEvent);
          gamification({
            name: `CLOSE_${PILET_NAMES.FINTECH}`,
            type: 'CLOSE_APP'
          });
          gamification({
            name: `OPEN_LENDING_LOANS`,
            type: 'OPEN_APP'
          });
        } else {
          history.pushState(
            '',
            '',
            !isEmpty(nextScreen) ? `/${nextScreen}` : '/'
          );
          var popStateEvent = new PopStateEvent('popstate', {});
          dispatchEvent(popStateEvent);
          gamification({
            name: `CLOSE_${PILET_NAMES.FINTECH}`,
            type: 'CLOSE_APP'
          });
          gamification({
            name: `OPEN_${nextScreen}`,
            type: 'OPEN_APP'
          });
        }
      } else if (action === 'openKYC') {
        setItem(STORAGE_KEYS.COAPPLICANT_AUTH_CONFIG, agnetUser);
        initializeContainer.updateKycInfo(agnetUser);
        redirectTo(`/kyc-select`);
        gamification({
          name: `OPEN_${PILET_NAMES.EKYC}`,
          type: 'OPEN_APP'
        });
      }
      else if(action === 'openRupify'){
        console.log("opening rupify ***")
        window.location.replace(rupifyUrl)
      }
    });
  };
  useEffect(() => {
    const hasPersona = getItem(STORAGE_KEYS.USER_PERSONA);
    const isAuthData = hasPersona ? true : false;
    if (isEmpty(query)) {
      handleIframe(isAuthData);
    }

    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams && queryParams.get('loggedinUserId')) {
      const digioQueries = {
        loggedinUserId: queryParams.get('loggedinUserId')
      }

      setDigioParams(`?loggedinUserId=${digioQueries.loggedinUserId}&userType=${queryParams.get('userType')}`);
    }

    if (queryParams && queryParams.get("status") && queryParams.get("digio_doc_id") && queryParams.get("message")) {
      const digioQueries= {
        status: queryParams.get("status"),
         digio_doc_id: queryParams.get("digio_doc_id"),
         message: queryParams.get("message"),
         loggedinUserId: queryParams.get('loggedinUserId'),
      }
      setDigioParams(`?status=${digioQueries.status}&digio_doc_id=${digioQueries.digio_doc_id}&message=${digioQueries.message}&loggedinUserId=${digioQueries.loggedinUserId}&userType=${queryParams.get('userType')}`);
    }

    window.addEventListener("message", (event) => {
      const action = get(event, "data.action", "");
      if (action === "digio_redirect") {
        const digioURL = get(event, "data.data.url", "");
        console.log(action, " data", event.data, '\n digioURL', digioURL);
        if (digioURL) {
          window.location.href = digioURL + `?redirect_url=${encodeURIComponent(window.location.href)}`;
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!isEmpty(query)) {
      const params: any = parseQueryParams(query);
      setParams(params);
      if (params && params.userId) {
        const authData = getItem(STORAGE_KEYS.AUTH_CONFIG);
        generateCode(authData, params);
      }
    } else {
      setD({
        ...d,
        showFrame: true
      });
      gamification({
        name: `OPEN_${PILET_NAMES.FINTECH}`,
        type: 'OPEN_APP'
      });
    }
  }, [query]);

  useEffect(() => {
    if (isSuccess) {
      setD({
        ...d,
        showFrame: true
      });
      gamification({
        name: `OPEN_${PILET_NAMES.FINTECH}`,
        type: 'OPEN_APP'
      });
      handleIframe();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isFailed) {
      setModal(true);
      setD({
        showFrame: false,
        isLoading: false
      });
    }
  }, [isFailed]);

  return (
    <div className='w-screen h-screen'>
      {isFailed && (
        <>
          <Header isAuthorised />
          <NCModal
            title='Failed'
            description='Failed to launch Fintech'
            showModal={showModal}
            buttons={[
              {
                title: 'Ok',
                callback: () => {
                  setModal(false);
                  redirectTo('/');
                }
              }
            ]}
          />
        </>
      )}
      {d.showFrame ? (
        <>
          {d.isLoading && (
            <>
              <Loading />
              <Header isAuthorised showHeader />
            </>
          )}
          <iframe
            allow="geolocation"
            className='w-full h-full'
            onLoad={hideLoading}
            src={fintechConfig.url + digioParams}
            id='loansframe'
          ></iframe>
        </>
      ) : (
        <>
          {!isFailed && (
            <>
              <Loading />
              <Header isAuthorised showHeader />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Loans;
